import React from 'react'
import { useTranslation } from 'react-i18next'
import { v4 } from 'uuid'
import PersonChangesLabelAndData from './PersonChangesLabelAndData'
import HideButtonAndExtras from './HideButtonAndExtras'
import usePersonChangesTable from './usePersonChangesTable'

function NewChangesCell({ rows, idsMetadata, metadata, personChangesDispatch, personChangeGroup, changeType }) {
  const { t } = useTranslation()
  const { sortRows } = usePersonChangesTable()
  const sortedRows = sortRows(rows)
  return (
    <>
      {sortedRows.map((row, index) => {
        let newValue = ''
        if (row.newValue) {
          newValue = row.newValue
          if (row.key === 'CHANGE_ID') {
            return null
          }
          if (row.key === 'SCOPE') {
            newValue = t(`changes.fieldType.scope.${row.newValue}`, row.newValue)
          } else if (row.key === 'CONCLUSION_TYPE') {
            newValue = t(`changes.fieldType.conclusionType.${row.newValue}`, row.newValue)
          } else if (row.key === 'DISMISSED_SUGGESTION_TYPE') {
            newValue = t(`changes.fieldType.dismissedSubmissionType.${row.newValue}`, row.newValue)
          } else if (row.key === 'TYPE') {
            newValue = t(`changes.fieldType.type.${row.newValue}`, row.newValue)
          } else if (row.key === 'RELATIONSHIP_TYPE') {
            newValue = t(`changes.fieldType.relationshipType.${row.newValue}`, row.newValue)
          }
        }
        return (
          <React.Fragment key={v4()}>
            <PersonChangesLabelAndData
              label={t(`changes.field.label.${row.key}`, row.key)}
              data={newValue}
              idsMetadata={idsMetadata}
              changeType={changeType}
            />
            {index === 0 && (
              <HideButtonAndExtras
                metadata={metadata}
                personChangesDispatch={personChangesDispatch}
                personChangeGroup={personChangeGroup}
              />
            )}
          </React.Fragment>
        )
      })}
    </>
  )
}

export default NewChangesCell
